baseApp.filter('capitalize', ['TranslationService', function(TranslationService) {
    return function(input, slash) {
        if(input == null){
            return "";
        }
        if (typeof input === 'boolean') {
            return input ? TranslationService.translate('yes') : TranslationService.translate('no');
        } else if (typeof input === 'number') {
            input = input + '';
        }

        input = input.replace('_', ' ');

        var inputSplitted = input.split(' ');
        var result = '';

        for(var i = 0; i < inputSplitted.length ; i++) {
            var part = inputSplitted[i];
            var translatedPart = TranslationService.translate(part);

            if (!translatedPart) {
                var lowerCasePart = part.toLowerCase();
                translatedPart = lowerCasePart.substring(0,1).toUpperCase() + lowerCasePart.substring(1);
            }

            result += translatedPart;

            if(slash && i< inputSplitted.length - 1){
                result += "/";
            }
            else {
                result += " ";
            }

        }
        return result.trim();
    }
}]);

baseApp.filter('domainsFilter', [function(provider) {
    return function (object, provider) {
        var array = [];
        angular.forEach(object, function (person) {
            if (person.provider == provider)
                array.push(person);
        });
        return array;
    };
}]);

baseApp.filter('tagExist', [ function(tags) {
				return function (object, tags) {
								var array = [];
								angular.forEach(object, function (provider) {
												if (!provider.requiredTag || tags.includes(provider.requiredTag))
																array.push(provider);
								});
								return array;
				};
}]);

baseApp.filter('range', function() {
  return function(input, total) {
    total = parseInt(total);
    for (var i=0; i<total; i++)
      input.push(i);
    return input;
  };
});

baseApp.filter('startFrom', function() {
    return function(input, start) {
        start = +start; //parse to int
        return input.slice(start);
    }
});

baseApp.filter('removeSpecialChars', [function() {
    return function(string) {
        if (!angular.isString(string)) {
            return string;
        }
        return string.replace(/(:|[\s]|\.|\[|\]|,|'|\/|\\|!|@|#|\$|\%|\^|\&|\*|\(|\))/g, "_").replace(/(\r\n\t|\n|\r\t)/gm,"_");
    };
}]);

baseApp.filter('camelCaseToHuman', function() {
    return function(input) {
        return input.charAt(0).toUpperCase() + input.substr(1).replace(/[A-Z]/g, ' $&');
    }
});

baseApp.filter('highlight', ['$sce' ,function($sce) {
    return function(text,markPart) {
        if (!markPart) {
            return $sce.trustAsHtml(text);
        }
        return $sce.trustAsHtml(text.replace(new RegExp(markPart, 'gi'), '<span class="highlightedText">$&</span>'));
    }
}]);

baseApp.filter('ellipsis', function () {
    return function (value, max) {
        if (!value || typeof value !== "string") return '';
        if(value.length <= max) return value;
        return value.substring(0,max) + "...";
    };
});

baseApp.filter('capitalize_first', function(){
        return function(str){
                return str.charAt(0).toUpperCase() + str.slice(1);
        };
    });

baseApp.filter('bytes', function() {
    return function(bits, precision, convert, withoutUnits) {
        if(bits === 0 || isNaN(parseFloat(bits)) || !isFinite(bits)) return '0' + (withoutUnits ? '' : ' B');
        var bytes = bits;
        if(convert) bytes = bytes / 8;
        if(typeof precision === 'undefined') precision = 1;
        var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'],
            number = Math.floor(Math.log(Math.ceil(bytes)) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  (withoutUnits ? '' : ' ' + units[number]);
    }
});


baseApp.filter('fromUnit', function() {
    return function(value, unit) {
        var mul = 1;
        switch(unit){
        case "MB": mul =  1024*1024;
        break;
        case "KB": mul = 1024;
        break;
        }
        return (isNaN(parseFloat(value)) || !isFinite(value)) ? 0 : (value*mul).toFixed(0) ;
    }
});

baseApp.filter('toUnit', function() {
    return function(bytes,unit) {
            var div = 1;
            switch(unit){
            case "MB": div =  1024*1024;
            break;
            case "KB": div = 1024;
            break;
            }
        return (isNaN(parseFloat(bytes)) || !isFinite(bytes)) ? 0 : (bytes/div).toFixed(1) ;
    }
});


baseApp.filter('networkRangeType', function(){
    return function(value) {
    if(value){
        value = value.replace("ROUTED_ROUTE", " (Routed Range)");
        value = value.replace("DIRECT_ROUTE", " (Direct Range)");
        value = value.replace("NATIVE_RANGE", " (Native Range)");
        value = value.replace("VLAN", " (VLAN)");
        value = value.replace("PUBLIC_ALT_WAN", " (public Alt. WAN)");
        value = value.replace("ALT_WAN", " (Alt. WAN)");

        return value;
    }
    }
});

baseApp.filter('vpnUserStatus', function(){
    return function(value) {
        switch (value) {
            case 'DISABLED':
                return 'Disabled';
             case 'ACTIVE':
                return 'Configured'
             case 'LOCKED':
                return 'Locked';
             case 'NEW':
                return 'New';
             case 'PENDING_USER_CONFIGURATION':
                return 'Invitation Sent';
             case 'PENDING_MFA_CONFIGURATION':
                return 'MFA invitation Sent';
            case 'PENDING_CODE_GENERATION':
                return 'Requires new code';
            default:
            return '';
        }
    }
});

baseApp.filter('importTypeDisplayName', function(){
				return function(value) {
								switch (value) {
												case 'REGULAR':
																return 'User defined';
												case 'SYSTEM':
																return 'SYSTEM'
												case 'SCIM':
																return 'SCIM defined';
												case 'LDAP':
																return 'LDAP defined';
												default:
																return '';
								}
				}
});

baseApp.filter('bits', function() {
    return function(bits, precision, ignoreUnits, di) {
        if (bits === 0 || isNaN(parseFloat(bits)) || !isFinite(bits)) return '0' + (ignoreUnits ? '' :' b');
        if (typeof precision === 'undefined') precision = 1;
        var units = ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb'],
            number = Math.floor(Math.log(Math.ceil(bits)) / Math.log(1000));
        var newNumber = (bits / Math.pow(1000, Math.floor(number)));
        return newNumber.toFixed(precision) +  '' + (ignoreUnits ? '' : (' ' + units[number]) );
    }
});

baseApp.filter('haveValue', function() {
    return function(input, map) {
        var out = [];
        for (var i = 0; i < input.length; i++) {
            if(map[input[i].label] && map[input[i].label].values && map[input[i].label].values.length > 0){
                out.push(input[i]);
            }
        }
        return out;
    }
});

baseApp.filter('orderObjectBy', function() {
    return function(items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function(item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            if(!a[field]) return 1;
            if(!b[field]) return -1;
            return (a[field] > b[field] ? 1 : -1);
        });
        if(reverse) filtered.reverse();
        return filtered;
    };
});

baseApp.filter('secondsToDateTime', function() {
    return function(seconds) {
        return new Date().setTime(new Date().getTime() - (seconds * 1000));
    };
});

baseApp.filter('timeToMoment', ['GeneralUtilsService', function(GeneralUtilsService) {
    return function(time) {
        return time ? moment(GeneralUtilsService.getTimeInMiliseconds(time)).calendar() : "";
    };
}]);

baseApp.filter('durationHumanize', function() {
    return function(milliseconds) {
        return moment.duration(parseInt(milliseconds)).humanize();
    };
});

baseApp.filter('duration', function() {
    return function(milliseconds, seconds) {
        var momentObj = moment.duration(parseInt(milliseconds));
        return (momentObj.hours()? (momentObj.hours() + (momentObj.hours() == 1? " hour " : " hours ")) : "") + momentObj.minutes() + " minutes" + ((seconds && momentObj.minutes() < 5)? (" " + momentObj.seconds() + " seconds") : "");
    };
});

baseApp.filter('shortenNumber', function(){
    return function(origNumber, fractionSize){
        if (origNumber === 0 || isNaN(parseFloat(origNumber)) || !isFinite(origNumber)) return '0';
        var units = ['', 'K', 'M', 'B', 'T', 'Q'],
            number = Math.floor(Math.log(Math.ceil(origNumber)) / Math.log(1000));

        var result = (origNumber / Math.pow(1000, Math.floor(number)));
        var precision = 1;
        if (result % 1 === 0)
            precision = 0;

        return result.toFixed(precision) +  ' ' + units[number];
    };
});

baseApp.filter('trustAsResourceUrl', ['$sce', function($sce) {
    return function(val) {
        return $sce.trustAsResourceUrl(val);
    };
}]);

baseApp.filter('toUTC', function(){
    return function(val) {
        return moment.utc(val).format();
    }
});

/**
  * convert the vale received to millisecond since 1970
**/
baseApp.filter('toMillis', function(){
    return function(val) {
        var date = new Date(val);
        return date.getTime();
    }
});

baseApp.filter('numberFixedLen', function () {
        return function (n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        };
    });

baseApp.filter('orderObjectByFunc', function() {
    return function(items, field,type, reverse) {
        var filtered = [];
        angular.forEach(items, function(item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            if(!field(a,type)) return 1;
            if(!field(b,type)) return -1;
            return (field(a,type)> field(b,type) ? 1 : -1);
        });
        if(reverse) filtered.reverse();
        return filtered;
    };
});

baseApp.filter('filterByNameAndEmail', function() {
    return function(items, field) {
        if(!field){
            return items;
        }
        var filtered = [];
        angular.forEach(items, function(item) {
            if(item.email.toLowerCase().includes(field.toLowerCase()) || item.name.toLowerCase().includes(field.toLowerCase())){
                filtered.push(item);
            }
        });
        return filtered;
    };
});

baseApp.filter('socketVersion', function(numberFilter) {
    return function (version) {
        var FIRST_VER3_SOCKET = 854;

        if (version == null) {
            return 0;
        }
        version = version + "";
        // new format already includes the period, no need to change
        if (version.indexOf(".") > -1) {
            return version;
        } else {
            var versionInt = parseInt(version);

            if (isNaN(versionInt) || versionInt < 0) {
                return version;
            }

            if (versionInt > FIRST_VER3_SOCKET) {
                return "3.0." + version;
            } else {
                return "2.0." + version;
            }
        }
    } ;
});

baseApp.filter('absolute', function() {
    return function (num) {
        return Math.abs(num);
    }
});

baseApp.filter('statesColoring', function() {
    var colorsLegend = {
                "ERROR": '#ff00005e',
                "SUCCESS": '#00ff005e',
                "WARNING": '#ffa5005e',
                "IN_PROGRESS": '#ffff005e',
                "SERVER_RESTART": 'lavender',
                "PAUSED": 'lightgrey'
    }
    return function (state) {
        return colorsLegend[state];
    }
});

baseApp.filter('commaSeparate', function() {
    return function (string) {
        if (string)
            return string.replace(/,(?=\S)/g,", ");;
        return string;
    }
});

baseApp.filter('limitNumOfLines', function() {
    return function (string, limit) {
        var lines = string.split('\n');

        if(lines.length > limit){

            let result = '';

            for(let i=0; i<limit; i++){
                result = result + lines[i];

                if(i+1 < limit){
                    result +=('\n');
                }
            }
            return result;
        }
    return string;
  }
});

baseApp.filter('orderPreference', function() {
    return function(index, fallbackStrValue) {
        const priorities = ['Primary', 'Secondary', 'Tretiary', 'Quaternary', 'Quinary', 'Senary', 'Septenary', 'Octonary', 'Nonary', 'Denary'];
        if (index < priorities.length) {
            return priorities[index];
        }
        return fallbackStrValue + (index + 1);
    }
});

baseApp.filter('use', function ($filter, $injector) {
   return function () {
       var filterName = [].splice.call(arguments, 1, 1)[0];
       return $injector.has(filterName + 'Filter') ? $filter(filterName).apply(null, arguments) : arguments[0];
   };
});

baseApp.filter('intToDay', function() {
    //follows the ISO-8601 standard, from 1 (Monday) to 7 (Sunday).
    return function (num) {
        switch (num) {
            case 1:
                return 'Mon';
            case 2:
                return 'Tue';
            case 3:
                return 'Wed';
            case 4:
                return 'Thu';
            case 5:
                return 'Fri';
            case 6:
                return 'Sat';
            case 7:
                return 'Sun';
        }
    }
});

baseApp.filter('intToTimeSlot', function() {
    return function (begin) {

        let str = "";

        str += new moment(begin, 'HH:mm').format('HH:mm');
        str += " - ";

        let end = begin + 2;
        end = (end < 24) ? end : end - 24;
        str += new moment(end, 'HH:mm').format('HH:mm');

        return  str;
    }
});

baseApp.filter('momentToHourInt', function() {
    return function (begin) {
       return new moment(begin, 'HH:mm').hour();
    }
});

baseApp.filter('isUpgradedToIcon', function() {
    return function (status, isLowerThanTargetVersion) {
        if(status === "SUCCESS"){
            if (isLowerThanTargetVersion){
                return 'prompt';
            }else{
                return 'allow';
            }
        }else if (status === "FAIL"){
            return 'block'
        } else if (status === "PENDING" || status === "STARTED") {
            return '';
        }
        else {
            return 'prompt';
        }
    }
});

baseApp.filter('dictionaryToString', function() {
    return function (dictionary) {
        let str = JSON.stringify(dictionary);
        return str.replace(/["{}]/g, "").replace(/[:]/g, ": ");
    }
});

baseApp.filter('yesNo', function() {
    return function (bool) {
        if (bool){
            return "Yes";
        }else{
            return "No";
        }
    }
});

baseApp.filter('isoToDayMonthYear', function(){
    return function(val) {
        let date = (val) ? new moment(val).format('L') : null;
        return date;
    }
});

baseApp.filter('dontPresentIfTimePasssed', function(){
    return function(val) {
        let hasPassed = new moment(val).isBefore();
        if (hasPassed) return;
        return val;
    }
});

baseApp.filter('getSiteConnTypeString', function(){
    return function (str) {
       let vSocket = 'vSocket ';
       if (str === 'AWS1500'){
           return  vSocket + 'AWS';
       }else if (str === 'AZ1500'){
           return vSocket + 'Azure'
       }else if (str === 'ESX1500'){
           return vSocket + 'ESX';
       }else {
           return 'Socket ' + str.replace(/[BR_2]/g, "");
       }
    }
});
